import { Component } from '@verndale/core';
import $ from 'jquery';
import jQueryBridget from 'jquery-bridget';
import Flickity from 'flickity';
import 'flickity-as-nav-for/as-nav-for';
import { BREAKPOINTS } from '../constants';

class ImageGallery extends Component {
  setupDefaults() {
    this.dom = {};

    // This is needed for Flickity to work properly with Webpack and the toolkit
    // Aside from the original MarineMax (Galeon) repo code :(
    Flickity.setJQuery($);
    jQueryBridget('flickity', Flickity, $);

    this.isMobile = !window.matchMedia(
      `(min-width: ${BREAKPOINTS.TABLET_LANDSCAPE}px)`
    ).matches;
    this.initCarousel();
  }

  addListeners() {}

  initCarousel() {
    const $imageGalleries = $('section.image-gallery');
    if ($imageGalleries.length) {
      $imageGalleries.each((i, el) => {
        const $el = $(el);
        const $mainSlider = $el.find('.image-gallery__main-slider');
        const $navSlider = $el.find('.image-gallery__nav-slider');
        const $status = $el.find('.image-gallery__slide-count');

        if (this.isMobile) {
          $mainSlider.flickity({
            prevNextButtons: true,
            percentPosition: false,
            pageDots: false
          });
        } else {
          $mainSlider.flickity({
            pageDots: false,
            prevNextButtons: true
          });

          $navSlider.flickity({
            asNavFor: '.image-gallery__main-slider',
            percentPosition: false,
            contain: true,
            pageDots: false,
            prevNextButtons: false
          });
        }

        const flkty = $mainSlider.data('flickity');

        function updateStatus() {
          const cellNumber =
            flkty && flkty.selectedIndex ? flkty.selectedIndex + 1 : 1;
          $status.text(
            `${String(`00${cellNumber}`).slice(-2)} / ${String(
              `00${flkty.cells.length}`
            ).slice(-2)}`
          );
        }
        updateStatus();

        $mainSlider.on('select.flickity', updateStatus);
      });
    }
  }
}

export default ImageGallery;
